import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { getNews } from '../../../services/news/newsAPI';
import Cookies from 'js-cookie';

export default function ListeNews() {
    // LISTE DES NEWS
    const [ListeNews, setListeNews] = useState([])
    //------- INIT LANGAGE 
    const language = Cookies.get('locale')
    //------------- Traduction -------------
    const [t] = useTranslation("global");

    useEffect(() => {
        getNews().then((result) => {
            if (result?.data?.code === 200) {
                setListeNews((result?.data?.data))
            }
        }).catch((err) => {
            console.log(err)
        });
    }, [])

    return (
        <div className="container">
            <div className="shop-pagination pb-3">
                <div className="container">
                    <div className="card">
                        <div className="card-body p-2">
                            <div className="d-flex align-items-center justify-content-between"><small className="ms-1">{t("Toutes les actualités")} </small>
                            </div>
                        </div>
                    </div>
                    <div className="row g-3 mt-3">
                        {/* Single Blog Card */}
                        {ListeNews?.length !== 0 ? ListeNews?.map((items, keys) =>
                            <div className="col-12 col-sm-6 col-md-6" key={keys}>
                                <div className="card position-relative shadow-sm">
                                    <img className="card-img-top" src={items.image !== null ? process.env.REACT_APP_IMAGE + items.image : "img/bg-img/23.jpg"} alt="news_images" height={"150px"} />
                                    <div className="card-body">
                                        <span className="badge bg-purple rounded-pill mb-2 d-inline-block">{moment(items.created_at).format("DD MMMM YYYY ")}</span>
                                        <h5 className="mb-1 fz-14" >{language==="fr"? items.titre : items.titre_en} </h5>
                                        <a className="text-purple float-end" href={"/details_news&id=" + items.id}>{t("Lire la suite")} ...  </a>
                                    </div>
                                </div>
                            </div>
                        ) : (<div className="col-12 col-sm-12 col-md-12" >
                            <div className=" text-center">
                                <img className="text-center mb-3" width={150} src="../img/bg-img/nodata.png" alt="news_images" />
                                <h6 className='text-purple'>{t("Aucune actualité pour le moment")} </h6>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
        </div>
    )
}
